import AdminLayout from '../../templates/AdminLayout';
import DailyNewPatientList from '../../UI/organisms/etc/DailyNewPatientList';

const PatientCountPage = () => {
  return <AdminLayout title={'일일 신규 등록 환자 수'} content={<DailyNewPatientList />} sideType={0} />;
};

export default PatientCountPage;
